import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[footer-page-size-dropdown-template]',
  standalone: false,
})
export class FooterPageSizeDropDownTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
